import { TuneOutlinedIcon } from 'tuui';
import CommonCollapsibleCard from 'components/CommonCollapsibleCard/CommonCollapsibleCard';
import { SectionHeader } from 'modules/campaigns/components';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { SubscriptionEntities } from '../SubscriptionEntities/SubscriptionEntities';
import styles from './subscriptionSetupSection.module.scss';

export const SubscriptionSetupSection = () => {
    return (
        <CommonCollapsibleCard
            id="SUBSCRIPTION_SETUP"
            header={
                <SectionHeader
                    headerIcon={<TuneOutlinedIcon />}
                    headerText={
                        <FormattedMessage
                            id="push-api.subscription.creator.properties.step.title"
                            defaultMessage="Subscription Properties"
                        />
                    }
                />
            }
            containerClassName={styles['card-container']}
        >
            <SubscriptionEntities />
        </CommonCollapsibleCard>
    );
};
